
import { computed, defineComponent, PropType, ref, toRef, watch } from "vue";
import { TranslationService } from "@/core/services/TranslationService";
import VZModal from "@/components/content/VZModal.vue";
import RoleDetail from "@/views/user/views/RoleDetail.vue";
import { IRole } from "@/interfaces/iRole";

export default defineComponent({
  name: "role-detail-modal",
  emit: ["close-detail"],
  components: { VZModal, RoleDetail },
  props: {
    value: { type: Boolean, default: false },
    viewName: { type: String, default: "" },
    data: { type: Object as PropType<IRole>, required: true },
    loading: { type: Boolean, default: false },
    showDialog: { type: Boolean, default: false },
  },
  setup(props, { emit }) {
    const title = computed(() => {
      return props?.data?.roleName;
    });
    const t = (key: string) => {
      return TranslationService.translate(key);
    };
    const close = () => {
      emit("close-detail");
    };
    return {
      t,
      title,
      close,
    };
  },
});
